/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const DvdVideo = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 26 12" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M14.81 2.26l1.67-2h5.31c2.7 0 4.58 1.41 4.15 3.22-.43 1.81-3 3.22-5.68 3.22H16.7l1.07-4.5h2.51l-.73 3.09h.56c1.5 0 2.92-.55 3.22-1.81.3-1.26-.72-1.78-2.33-1.78h-3l-5.77 6.52-2.31-6.41a.37.37 0 0 0 0-.09s0-.06-.07-.05c-.07.01 0 .09 0 .1a.2.2 0 0 1 0 .08 3.22 3.22 0 0 1 .13 1.65c-.44 1.81-3 3.22-5.67 3.22H.71l1.07-4.5h2.51l-.73 3.09h.56c1.5 0 2.91-.55 3.21-1.81.3-1.26-.71-1.8-2.33-1.8H1.9L2.24.28h9.56l.67 2c.76 2.17.64 2.32.64 2.32s-.09-.14 1.7-2.3v-.04zM0 10c0-1 5.5-1.74 12.28-1.74 6.78 0 12.28.74 12.28 1.74s-5.5 1.74-12.28 1.74C5.5 11.74 0 11 0 10zm11.83.62c1.55 0 2.81-.26 2.81-.58 0-.32-1.26-.58-2.81-.58S9 9.7 9 10c0 .3 1.26.58 2.8.58l.03.04zM23.62 11.37h-.11l-.05.35h-.06l.05-.35h-.11v-.05h.29zM24.04 11.72h-.06v-.3l-.16.3-.07-.3-.1.3h-.05l.13-.4h.04l.07.27.14-.27h.06z" /></g>
      </g>
    </svg>
  </span>
);

DvdVideo.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

DvdVideo.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default DvdVideo;
